import React from "react";
import PropTypes from "prop-types";
import ActivationEmail from "components/v3/activation-email/ActivationEmail";
import styles from "./styles.module.scss";
import SubscriptionSuccessMessage from "components/v3/subscription-success-message/SubscriptionSuccessMessage";
import GoogleTracking from "services/GoogleTracking";

class SubscriptionActivationEmail extends React.Component {
    componentWillMount() {
        GoogleTracking.registerSubscriptionEvent("impression", "success_notsignedin_notexisting");
    }

    render() {
        return (
            <div className={ styles.body }>
                <SubscriptionSuccessMessage>
                    You successfully completed your purchase.
                </SubscriptionSuccessMessage>
                <div className={ styles.step }>
                    <ActivationEmail fromSubscriptionSuccess={ true } { ...this.props } />
                </div>
            </div>
        );
    }
}

SubscriptionActivationEmail.propTypes = {
    email: PropTypes.string,
    signInLink: PropTypes.string,
    grecaptchaApiKey: PropTypes.string,
    useRecaptcha: PropTypes.bool,
    errors: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    thinking: PropTypes.string
};

export default SubscriptionActivationEmail;
